<template>
  <div>
    <!-- 弹窗 -->
    <el-dialog
      title="专家退评"
      :visible.sync="dialogVisible"
      width="90%"
      :close-on-click-modal="false"
      :show-close="false"
      center
      :before-close="handleClose">
      <div v-if="submitSuccess" class="success-tip">
        <i class="el-icon-success success-icon"></i>
        <p>您已提交退评，请勿重复提交，直接关闭页面即可</p>
      </div>
      <div v-else-if="initError" class="error-tip">
        <i class="el-icon-warning error-icon"></i>
        <p>{{ errorMsg }}</p>
      </div>
      <el-form v-else :model="form" :rules="rules" ref="formRef">
        <el-form-item label="退评理由" prop="reason">
          <el-input v-model="form.reason" type="textarea" :rows="4" maxlength="200" show-word-limit placeholder="请输入退评理由"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="!initError && !submitSuccess" slot="footer" class="dialog-footer">
        <el-button type="primary"  v-loading.fullscreen.lock="fullscreenLoading" @click="submitReason">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import expertsReviewService from "@/api/review/expertsReviewApi";
import webutils from "@/utils/webutils";
export default {
  data() {
    return {
      dialogVisible: false,
      fullscreenLoading: false,
      submitSuccess: false, // 提交成功标志
      initError: false,     // 初始化错误标志
      errorMsg: '',         // 错误信息
      form: {
        id:'',
        reason: ''
      },
      rules: {
        reason: [
          { required: true, message: '请输入退评理由', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    this.form.id='';
    this.form.reason='';
    const id = this.$route.query.id
    this.form.id = id
    expertsReviewService.checkReviewExitUrl(id).then(res=>{
      this.dialogVisible=true;
    }).catch(err=>{
      this.dialogVisible=true;
      this.initError = true;
      this.errorMsg = webutils.parseErrorMsg(err);
    })

  },
  methods: {
    submitReason() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.fullscreenLoading = true;
          expertsReviewService.expertExitReviewByExpert(this.form).then(res => {
            this.submitSuccess = true;
            this.dialogVisible = true;
          }).catch((err)=>{
            this.initError = true;
            this.errorMsg = webutils.parseErrorMsg(err);
          }).finally(()=>{
            this.fullscreenLoading = false;
          });
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
::v-deep .el-dialog {
  border-radius: 8px;
}
::v-deep .el-textarea__inner {
  resize: none; /* 禁止调整大小 */
}
/* 对话框标题文字颜色 */
::v-deep .el-dialog__title {
  color: white;
}
/* 成功提示样式 */
.success-tip {
  text-align: center;
  padding: 20px;
}

.success-icon {
  font-size: 40px;
  color: #67C23A;
  margin-bottom: 10px;
}

/* 错误提示样式 */
.error-tip {
  text-align: center;
  padding: 20px;
}

.error-icon {
  font-size: 40px;
  color: #F56C6C;
  margin-bottom: 10px;
}

/* 提示文字样式 */
.success-tip p,
.error-tip p {
  font-size: 16px;
  margin: 0;
  color: #606266;
}
</style>


